import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import SearchFilterCreatePopover from "search-filter/components/search-filter-bar/SearchFilterCreatePopover";
import { Button } from "components/bootstrap";
import { Icon } from "components/common";
import useSearchFiltersFormActions from "search-filter/hooks/useSearchFiltersFormActions";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
const SearchFilterCreate = ({ showPopover, onChange }) => {
  const sendTelemetry = useSendTelemetry("search-filter");
  const { addFilter } = useSearchFiltersFormActions();
  const { t } = useTranslation("enterprise_search");
  const _onSave = useCallback(
    (searchFilter) => {
      addFilter(searchFilter);
      onChange();
      sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_FILTER_CREATED, {
        app_pathname: "search",
        app_action_value: "create"
      });
    },
    [addFilter, sendTelemetry, onChange]
  );
  const onCancel = useCallback(() => onChange(false), [onChange]);
  const onClick = useCallback(() => onChange(), [onChange]);
  return /* @__PURE__ */ React.createElement(SearchFilterCreatePopover, { onSubmit: _onSave, onCancel, show: showPopover }, /* @__PURE__ */ React.createElement(Button, { onClick, title: t("search_filter_create.create_new_filter"), bsSize: "small" }, /* @__PURE__ */ React.createElement(Icon, { name: "add" })));
};
export default SearchFilterCreate;
